import { Pipe, PipeTransform } from '@angular/core';
import { State } from '../enums/state.enum';

@Pipe({
  name: 'convertStateToString'
})
export class ConvertStateToStringPipe implements PipeTransform {

  transform(stateFromBackEnd: string, ...args: unknown[]): unknown {
    return State[stateFromBackEnd];
  }

}
